import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { VACANCY_MAIN_PAGE_PATH } from "utils/constants/paths";

const VacancyMainPage = Loadable(React.lazy(() => import("./View")));

export const VacancyMainPageRoute: IRouteItem = {
  path: VACANCY_MAIN_PAGE_PATH,
  element: React.createElement(VacancyMainPage),
  name: "Vacancy Main Page",
};
